import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import './EventCard.css';
import factions from '@/shared/enums/factions.mjs';
import { formatDuration } from '@/shared/utils/format/formatCompactDuration.mjs';
import { FACTION_COLORS } from '@/shared/enums/colors.mjs';
export default function DefeatedCard(t0) {
  const $ = _c(38);
  const {
    factionIndex,
    startTime,
    endTime,
    view: t1
  } = t0;
  const view = t1 === undefined ? "sector" : t1;
  const faction = factions[factionIndex];
  const color = FACTION_COLORS[factionIndex] || "var(--color-primary)";
  const isCampaign = view === "campaign";
  let timing = "\u2014";
  if (startTime && endTime) {
    const t2 = endTime - startTime;
    let t3;
    if ($[0] !== t2) {
      t3 = formatDuration(t2);
      $[0] = t2;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    const duration = t3;
    let t4;
    if ($[2] !== endTime) {
      t4 = new Date(endTime * 1000).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        timeZone: "UTC"
      });
      $[2] = endTime;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    const date = t4;
    timing = `${duration} · ${date}`;
  }
  let t2;
  if ($[4] !== color) {
    t2 = {
      "--accent-color": color,
      "--faction-color": color
    };
    $[4] = color;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== faction.icon) {
    t3 = <Image src={faction.icon} alt="" width={16} height={16} />;
    $[6] = faction.icon;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="sector-card-action" style={{
      color: "var(--color-gold-muted)"
    }}>Defeated</span>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== faction.name) {
    t5 = <span className="sector-card-title">{faction.name}</span>;
    $[9] = faction.name;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <div className="sector-card-header">{t3}{t4}{t5}</div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="sector-card-bar-label-row"><span className="sector-card-bar-label">ALL_SECTORS_CAPTURED</span></div>;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = `${faction.name} defeat progress`;
  const t9 = isCampaign ? 11 : 100;
  const t10 = isCampaign ? 11 : 100;
  let t11;
  if ($[15] !== color || $[16] !== isCampaign) {
    t11 = isCampaign ? <div className="sector-card-segments">{Array.from({
        length: 11
      }, _temp)}</div> : <div className="sector-card-bar-fill" style={{
      width: "100%",
      background: color
    }} />;
    $[15] = color;
    $[16] = isCampaign;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11 || $[20] !== t8 || $[21] !== t9) {
    t12 = <div className="sector-card-bar" role="progressbar" aria-label={t8} aria-valuenow={t9} aria-valuemin={0} aria-valuemax={t10}>{t11}</div>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t8;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = isCampaign ? "11/11" : "100%";
  let t14;
  if ($[23] !== t13) {
    t14 = <span className="sector-card-pct">{t13}</span>;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t12 || $[26] !== t14) {
    t15 = <div className="sector-card-bar-wrap">{t12}{t14}</div>;
    $[25] = t12;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== timing) {
    t16 = <div className="sector-card-meta"><span className="sector-card-points">{timing}</span></div>;
    $[28] = timing;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t15 || $[31] !== t16 || $[32] !== t6) {
    t17 = <div className="sector-card-content">{t6}{t7}{t15}{t16}</div>;
    $[30] = t15;
    $[31] = t16;
    $[32] = t6;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="sector-card-accent" />;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t17 || $[36] !== t2) {
    t19 = <div className="sector-card sector-card-defeated" style={t2}>{t17}{t18}</div>;
    $[35] = t17;
    $[36] = t2;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  return t19;
}
function _temp(_, i) {
  return <div key={i} className="sector-card-segment sector-card-segment--captured" />;
}